export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',

  // EDI MessageStatusTag
  'component.messageStatus.delivered': 'Delivered',
  'component.messageStatus.sent': 'Sent',
  'component.messageStatus.received': 'Received',
  'component.messageStatus.parsed': 'Parsed',
  'component.messageStatus.validatedIn': 'Inbound Validated',
  'component.messageStatus.created': 'Created',
  'component.messageStatus.validatedOut': 'Outbound Validated',
  'component.messageStatus.sending': 'Sending',
  'component.messageStatus.parseFailed': 'Parse Failed',
  'component.messageStatus.rejectedIn': 'Inbound Rejected',
  'component.messageStatus.rejectedOut': 'Outbound Validation Failed',
  'component.messageStatus.deliverFailed': 'Delivery Failed',
  'component.messageStatus.sendFailed': 'Send Failed',
  'component.messageStatus.replayPending': 'Replay Pending',
  'component.messageStatus.retryPending': 'Retry Pending',

  'component.messageStatus.ackType.transport': 'Transport',
  'component.messageStatus.ackType.syntax': 'Syntax',
  'component.messageStatus.ackType.app': 'App',

  'component.messageStatus.ackStatus.waiting': 'Waiting',
  'component.messageStatus.ackStatus.timeout': 'Timeout',
  'component.messageStatus.ackTooltip.waiting': 'Waiting for {type} ACK',
  'component.messageStatus.ackTooltip.waitingDeadline':
    'Waiting for {type} ACK (Deadline: {deadline})',
  'component.messageStatus.ackTooltip.timeout': 'ACK timeout at: {deadline}',
  'component.messageStatus.ackTooltip.unknown': 'Unknown',
  'component.messageStatus.ackTooltip.rejectReason':
    'Rejection Reason: {reason}',
  'component.messageStatus.ackTooltip.rejected': 'ACK Rejected/Abnormal',
};
